import React from 'react';
import { Security, LoginCallback } from '@okta/okta-react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginCallbackError from './components/Okta/LoginCallbackError';
import AuthUserProvider from './hooks/useAuthUser'; // Import the provider
import AdminDashboard from './AdminDashboard';
import SecureRoute from './SecureRoute'; // Import the custom SecureRoute
import './App.css';
import { oktaAuth } from './config'; // Import the oktaAuth instance
import Dashboard from './Dashboard';
import Generator from './Generator';
import { ModelProvider } from './context/ModelContext';
import { ReferentialsProvider } from './context/ReferentialsContext';


function App() {

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    // Redirect to the original URI after login
    window.location.replace(originalUri);
  };

  /*
  const LoginCallbackErrorProps = {
    error: {
      errorCode: 'Xaccess_denied',
      errorSummary: 'XXX An error occurred during login callback.'
    }
  };
  */

  return (
    <Router>
      <Security
        oktaAuth={oktaAuth}
        restoreOriginalUri={restoreOriginalUri} // Pass the restoreOriginalUri function

      >
        <div className="App">
          <AuthUserProvider>
            <ModelProvider>
              <ReferentialsProvider>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/login/callback" element={<LoginCallback errorComponent={LoginCallbackError} />} /> {/* Login callback route */}
                  <Route path="/dashboard" element={<SecureRoute element={<Dashboard />} redirectTo="/dashboard" />} />
                  <Route path="/generator" element={<SecureRoute element={<Generator />} redirectTo="/generator" />} />
                  <Route path="/admin" element={<SecureRoute element={<AdminDashboard />} redirectTo="/admin" />} />
                  {
                   // <Route path="/testokta" element={<LoginCallbackError {...LoginCallbackErrorProps} redirectTo="/testokta" />} />
                  }
                </Routes>
              </ReferentialsProvider>
            </ModelProvider>
          </AuthUserProvider>
        </div>
      </Security>
    </Router>
  );
}

export default App; 
